
















































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'
import BillApi from '@/api/bill2'

@Component({})
export default class PersonalInjury extends Mixins(addTaskMixin) {
	public taskType: any = '20'
	public activated() {}
}
